


/**
 * Disable "Add to Cart" buttons for sold-out variants based on Zapiet Eats limits.
 * Adds a clean "SOLD OUT" badge and disables the button without touching other elements.
 * Includes a debug log for product title to help find unintended changes.
 */
function removeZapietDisable() {
  const styles = document.querySelector("#zapietDisable");
  if (styles) styles.remove();
}


function getFromSessionStorage(key) {
  const storeUrl = window.Shopify.shop;
  
  const value = sessionStorage.getItem(storeUrl + '.' + key);

  if (value) {
      try {
          return JSON.parse(value);
      } catch (e) {
          return value;
      }
  }

  return null;
}

function updateProductAvailability() {
  removeZapietDisable();
  const selectedRestaurant = window.ZapietEats?.getSelectedRestaurant?.() ?? getFromSessionStorage("selectedLocation");
  const selectedMenu = window.ZapietEats?.getSelectedMenu?.() ?? getFromSessionStorage("selectedMenu");
  const selectedDateRaw = window.ZapietEats?.getSelectedDate?.() ?? getFromSessionStorage("selectedDate");
  const variantMetafields = window.ZapietWidgetConfig?.variant_metafields;

  if (!selectedRestaurant || !selectedMenu || !selectedDateRaw || !variantMetafields) {
    console.warn("Zapiet Eats: Required data is not fully loaded.");
    return;
  }

  const selectedDate = new Date(selectedDateRaw + 'Z').toISOString().split('T')[0];
  const restaurantId = selectedRestaurant.id;
  const menuId = selectedMenu.id;

  document.querySelectorAll(".t4s-product").forEach(card => {
    const optionsStr = card.getAttribute("data-product-options");
    if (!optionsStr) return;

    let productData;
    try {
      productData = JSON.parse(optionsStr);
    } catch (e) {
      console.error("Zapiet Eats: Invalid JSON in data-product-options", e);
      return;
    }

    // Variants array expected, fallback to one variant
    const variants = productData.Variants || [productData.VariantFirstID].filter(Boolean);

    if (variants.length === 0) {
      // No variants info, just skip
      return;
    }

    let allUnavailable = true;
    let allSoldOut = true;

    variants.forEach(variantIdRaw => {
      const variantId = String(variantIdRaw);
      const metafields = variantMetafields[variantId] || {};
      const key = `limits.${restaurantId}.${menuId}.${selectedDate}`;
      const limitData = metafields[key];
      const remaining = limitData?.remaining;

      const isDateRestricted = !limitData; // no limitData means date restricted or not in menu
      const isSoldOut = typeof remaining === "number" && remaining <= 0;

      if (!isDateRestricted && !isSoldOut) {
        allUnavailable = false; // found at least one available variant
      }

      if (!isSoldOut) {
        allSoldOut = false; // found at least one variant not sold out
      }
    });

    // Prepare badge element
    let badge = card.querySelector(".zapiet-badge");
    if (!badge) {
      badge = document.createElement("div");
      badge.className = "zapiet-badge";
      badge.style.position = "absolute";
      badge.style.top = "10px";
      badge.style.left = "10px";
      badge.style.padding = "0.3em 0.6em";
      badge.style.borderRadius = "5px";
      badge.style.fontSize = "12px";
      badge.style.fontWeight = "bold";
      badge.style.zIndex = "5";
      card.prepend(badge);
    }

    // Add to Cart Button
    const addToCartBtn = card.querySelector("form[action*='/cart'] button[type='submit']");
    if (!addToCartBtn) return;

    if (!addToCartBtn.hasAttribute("data-original-label")) {
      addToCartBtn.setAttribute("data-original-label", addToCartBtn.innerText.trim());
    }

    if (allUnavailable) {
      badge.textContent = "UNAVAILABLE";
      badge.style.display = "block";
      badge.style.backgroundColor = "#9e9e9e";
      badge.style.color = "#fff";

      addToCartBtn.disabled = true;
      addToCartBtn.innerText = "UNAVAILABLE";
      addToCartBtn.setAttribute("aria-disabled", "true");
      addToCartBtn.classList.add("disabled");
      card.classList.add("zapiet-disabled");

    } else if (allSoldOut) {
      badge.textContent = "SOLD OUT";
      badge.style.display = "block";
      badge.style.backgroundColor = "#d32f2f";
      badge.style.color = "#fff";

      addToCartBtn.disabled = true;
      addToCartBtn.innerText = "UNAVAILABLE";
      addToCartBtn.setAttribute("aria-disabled", "true");
      addToCartBtn.classList.add("disabled");
      card.classList.add("zapiet-disabled");

    } else {
      badge.textContent = "AVAILABLE";
      badge.style.display = "block";
      badge.style.backgroundColor = "#388e3c";
      badge.style.color = "#fff";

      addToCartBtn.disabled = false;
      addToCartBtn.innerText = addToCartBtn.getAttribute("data-original-label");
      addToCartBtn.removeAttribute("aria-disabled");
      addToCartBtn.classList.remove("disabled");
      card.classList.remove("zapiet-disabled");
    }
  });
}

// Run on Zapiet Eats ready
document.addEventListener('zapieteats:ready', updateProductAvailability);
